var map = {
	"./excel-128": 211,
	"./excel-128.png": 211,
	"./olympic_rm_logo": 212,
	"./olympic_rm_logo.png": 212,
	"./olympic_rm_logo_no_bar": 213,
	"./olympic_rm_logo_no_bar.png": 213,
	"./philips_logo": 214,
	"./philips_logo.png": 214
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 261;